/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { reduxForm, Field } from 'redux-form';
import $ from 'jquery';
import { SubmitButton } from 'components/widgets/buttons';
import _ from 'lodash';
import { isMobile } from 'constants';
import SVG from 'components/widgets/icons/svg';
import { HiddenInput } from 'components/forms/form-elements';

// Non-input components
export class Form extends React.Component {
  componentDidMount() {
    const { preventAutoFocus } = this.props;
    const form = ReactDOM.findDOMNode(this);

    if (!isMobile && !preventAutoFocus) setTimeout(() => $(form).find('*:input[type!=hidden][type!=checkbox]:first').focus(), 0);
  }

  render() {
    const { children, CustomSubmitButton, customSubmitArea, submitting, formRef, ...props } = this.props;

    return (
      <form ref={formRef} {..._.omit(props, ['error', 'submitFailed', 'showFormErrorBeforeSubmit', 'preventAutoFocus'])}>
        {children}
        { !customSubmitArea &&
          <div className="submit-area">
            { CustomSubmitButton ?
              <CustomSubmitButton showLoading={submitting} /> :
              <SubmitButton showLoading={submitting} />
            }
            <FormError {..._.pick(props, ['error', 'submitFailed', 'showFormErrorBeforeSubmit'])} />
          </div>
        }
      </form>
    );
  }
}

export const SimpleReduxForm = reduxForm()(props => {
  const passed = _.omit(props, [
    'anyTouched',
    'asyncValidate',
    'asyncValidating',
    'blur',
    'change',
    'destroy',
    'dirty',
    'dispatch',
    'handleSubmit',
    'initialize',
    'initialized',
    'initialValues',
    'invalid',
    'pristine',
    'reset',
    'submitSucceeded',
    'touch',
    'untouch',
    'valid',
    'warning',
    'pure',
    'triggerSubmit',
    'autofill',
    'clearSubmit',
    'clearAsyncError',
    'submit',
    'array',
    'resetSection',
    'clearFields',
    'clearSubmitErrors',
    'onChange',
    'validate'
  ]);

  return <Form {...passed} onSubmit={props.handleSubmit} />;
});

export function Row({ className, children, label, ...props }) {
  return (
    <div {...props} className={className}>
      { label &&
        <label className="form-label">{label}</label>
      }
      <div className="form-row">
        {children}
      </div>
    </div>
  );
}

export function Subform({ className, children, ...props }) {
  const classes = classNames(className, 'subform');

  return (
    <div {...props} className={classes}>
      {children}
    </div>
  );
}

export function SubformHeader({ className, children, ...props }) {
  const classes = classNames(className, 'subform-header');

  return (
    <div {...props} className={classes}>
      {children}
    </div>
  );
}

export function CheckboxGroup({ className, label, children, ...props }) {
  const classes = classNames(className, 'checkbox-group');

  return (
    <div {...props} className={classes}>
      { label &&
        <label className="form-label">{label}</label>
      }
      {children}
    </div>
  );
}

export function FormGroup({ className, label, children, ...props }) {
  const classes = classNames(className, 'form-group-wrapper');

  return (
    <div {...props} className={classes}>
      { label &&
        <label className="form-label">{label}</label>
      }
      <div className="form-group">
        {children}
      </div>
    </div>
  );
}

export function FormConfirm({ title, children, name, ...props }) {
  return (
    <div className="form-confirm-box" {...props}>
      <Field component={HiddenInput} name={name} />
      <div className="form-confirm-arrow"></div>
      <div className="form-confirm-title">{title}</div>
      {children}
    </div>
  );
}

export function FormConfirmActions({ children, ...props }) {
  return (
    <div {...props} className="form-confirm-actions">{children}</div>
  );
}

export function FormConfirmAction({ label, children, svg, active, ...props }) {
  const classes = classNames('form-confirm-action', { 'form-confirm-action-active': active });

  return (
    <div {...props} className={classes}>
      <h3>
        {label}
        { svg && <SVG src={svg} /> }
      </h3>
      <p>{children}</p>
    </div>
  );
}

export function FormError({ error, submitFailed, showFormErrorBeforeSubmit }) {
  // If the form has a specific error, show it once the form is submitted (unless showFormErrorBeforeSubmit is
  // true, in which case show the error immediately)
  if (error && (showFormErrorBeforeSubmit || submitFailed)) {
    return <div className="full-form-invalid-alert">{error}</div>;
  }

  // If submit failed, but the form doesn't have a specific error, show the general error
  if (submitFailed) {
    return (
      <div className="full-form-invalid-alert">
        { error || 'Form invalid. Please review invalid fields.' }
      </div>
    );
  }

  // If there were no errors to show, just return null
  return null;
}
